<template>
  <div id="app" :style="styles">
    <router-view />
    <portal-target name="modal" slim></portal-target>
    <portal-target name="overflow-modal" slim></portal-target>
    <app-error-notification />
    <v-modal-target name="root-modal" />
    <v-modal-target name="sidebar-popup" />
    <v-modal-target name="promo-code-warning-modal" />
    <promo-code-warning-modal ref="promoCodeWarningModal" :error="promoCodeError" />
    <add-to-cart-notification />
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import { mapState } from 'vuex';

import AddToCartNotification from '@/components/cart/AddToCartNotification.vue';
import AppErrorNotification from '@/components/common/AppErrorNotification.vue';
import PromoCodeWarningModal from '@/components/cart/PromoCodeWarningModal.vue';

import { IdlePageTimer } from 'universkin-shared/src/utils/IdlePageTimer';

import { screenHeightMixin } from '@/mixins/screenHightMixin';
import { UserAlertService } from '@/services/UserAlertService';

import { types } from '@/store/types';
import { LOCALE } from '@/constants/locale';

import './assets/scss/styles.scss';
import './assets/scss/perfect-scrollbar-overwrite.scss';

const IDLE_TIMEOUT = 1000 * 60 * 60 * 6;

export default {
  name: 'App',
  components: {
    PromoCodeWarningModal,
    AddToCartNotification,
    AppErrorNotification
  },
  mixins: [screenHeightMixin],
  data() {
    return {
      promoCodeError: ''
    };
  },
  computed: {
    ...mapState({
      locale: types.state.LOCALE,
      savedHashedDataId: types.state.HASHED_DATA_ID,
      doctorSlug: types.state.DOCTOR_SLUG
    }),
    styles() {
      return this.locale === LOCALE.EL ? { 'font-family': 'Arial, sans-serif' } : {};
    }
  },
  created() {
    window.addEventListener('scroll', this.resetHashFromUrl);

    this.timer = new IdlePageTimer(this.onLogout, IDLE_TIMEOUT);
  },
  mounted() {
    UserAlertService.registerAlert(
      UserAlertService.ALERT_TYPE.INVALID_PROMO_CODE_WARNING,
      this.showPromoCodeWarningModal
    );
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.resetHashFromUrl);
    this.timer.stop();
  },
  methods: {
    showPromoCodeWarningModal(promoCodeError) {
      this.promoCodeError = promoCodeError;

      return this.$refs.promoCodeWarningModal.open();
    },
    redirectWelcomePage() {
      this.$router.push({
        name: 'WelcomePage',
        params: { doctorSlug: this.doctorSlug, hashedDataId: this.savedHashedDataId }
      });
    },
    resetHashFromUrl: debounce(function handlePageScroll() {
      if (this.$route.hash) {
        this.$router.replace({ hash: '' });
      }
    }, 100),
    async onLogout() {
      this.redirectWelcomePage();
    }
  }
};
</script>
